import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { AddCarForm } from './components/AddCarForm';
import { useLanguage } from '../../contexts/LanguageContext';

export default function AddCarPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleSuccess = () => {
    navigate('/warehouse');
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <Button variant="outline" size="sm" asChild className="border-slate-200">
              <Link to="/warehouse">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to warehouse
              </Link>
            </Button>
            <div>
              <h1 className="text-2xl font-semibold text-slate-900 tracking-tight">{t('warehouse.addCar')}</h1>
              <p className="text-slate-500 text-sm mt-0.5">{t('warehouse.addCarDesc')}</p>
            </div>
          </div>
        </div>
      </header>

      <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
        <AddCarForm onSuccess={handleSuccess} />
      </main>
    </div>
  );
}
